export * from './progress.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng2-progressbar/index.js
// module id = 1288
// module chunks = 18